export default __webpack_public_path__ + "static/media/img-0209-mexico-full-face.b2ee11fc.png";